var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellularConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Cellular Connection",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.468 1.7704C18.468 1.1608 18.0123 0.666622 17.4502 0.666622H16.4324C15.8703 0.666622 15.4146 1.1608 15.4146 1.7704V11.3364C15.4146 11.946 15.8703 12.4402 16.4324 12.4402H17.4502C18.0123 12.4402 18.468 11.946 18.468 11.3364V1.7704ZM11.3749 3.02145H12.3927C12.9548 3.02145 13.4105 3.52748 13.4105 4.15171V11.3101C13.4105 11.9343 12.9548 12.4403 12.3927 12.4403H11.3749C10.8128 12.4403 10.3571 11.9343 10.3571 11.3101V4.15171C10.3571 3.52748 10.8128 3.02145 11.3749 3.02145ZM7.23982 5.56574H6.22201C5.65988 5.56574 5.20419 6.07822 5.20419 6.71039V11.289C5.20419 11.9212 5.65988 12.4337 6.22201 12.4337H7.23982C7.80194 12.4337 8.25763 11.9212 8.25763 11.289V6.71039C8.25763 6.07822 7.80194 5.56574 7.23982 5.56574ZM2.18211 7.93216H1.1643C0.602174 7.93216 0.146484 8.43732 0.146484 9.06046V11.3171C0.146484 11.9402 0.602174 12.4454 1.1643 12.4454H2.18211C2.74423 12.4454 3.19992 11.9402 3.19992 11.3171V9.06046C3.19992 8.43732 2.74423 7.93216 2.18211 7.93216Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellularConnection);
export default __webpack_public_path__ + "static/media/CellularConnection.0dbef38d34634d2335bbac5809b04cd5.svg";
export { ForwardRef as ReactComponent };